import React, { PureComponent } from 'react';
import { Field, FieldArray } from 'redux-form';
import { Icon } from 'react-fa';
import { Editor } from '../index';

const renderItems = ({ fields, meta: { error } }) => (
  <div>
    <button
      className="btn btn-primary"
      type="button"
      onClick={() => fields.push()}>Add Item
    </button>

    <div className="col-lg-12">
      <div className="planet-list__items">
        {
          fields.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-xs-12" key={index}>
              <div className="planet-list__item">
                <button
                  className="btn btn-primary btn-remove"
                  type="button"
                  onClick={() => fields.remove(index)}><Icon name="remove"/></button>
                <Field
                  name={`${item}.body`}
                  component={Editor}
                  label={`Item #${index + 1}`}/>
              </div>
            </div>
          ))
        }
        {error && <li className="error">{error}</li>}
      </div>
    </div>
  </div>
);

const RenderFields = () => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <Field
          label="Title"
          name="body"
          component={Editor}/>
        <FieldArray
          name={`items`}
          component={renderItems}/>
      </div>
    </div>
  );
};


class List extends PureComponent {

  static type = 'Normal';

  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;
    return (
      <div className="planet-list">
        <RenderFields/>
      </div>
    );
  }
}


export default List




// WEBPACK FOOTER //
// ./src/components/list/List.js